export default "__VITE_ASSET__D8Xa5a96__"